import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  /** Roman numeral including its trailing period, e.g. "III." */
  numeral: string;
  title: ReactNode;
  /** Outer spacing for the heading row; omit when nesting inside another row. */
  className?: string;
}

/**
 * Heading row shared by all seven estimate/proposal sections.
 *
 * The numeral and the title render at the same size so they read as one
 * heading. Previously each section hand-rolled this markup, which let the
 * numeral drift a step smaller than the title in every copy.
 */
export function SectionHeading({ numeral, title, className }: SectionHeadingProps) {
  return (
    <div className={cn('flex items-baseline gap-2', className)}>
      <span className="font-newsreader text-xl font-semibold text-primary">
        {numeral}
      </span>
      <h2 className="font-newsreader text-xl font-semibold tracking-tight text-foreground">
        {title}
      </h2>
    </div>
  );
}
